import Vue from 'vue'
import MxRemark from './index.vue'

Vue.component('mx-remark', MxRemark)



// WEBPACK FOOTER //
// ./src/components/mx-remark/index.js